export const ORIGINATING_TICKET_ID = 'originatingTicketId';
export const SPLIT_TICKET_ID = 'splitTicketId';
export const SPLIT_TICKET_CREATION_TIMESTAMP = 'splitTicketCreationTimestamp';